import baseFor from './_baseFor.js';
import keys from './keys.js';

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

export default baseForOwn;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseForOwn.js
// module id = 1048
// module chunks = 3